export const PROJECT_HAS_PROXY = new Set([
  'wl',
  'dc',
  'mc',
  'twd',
  'tr',
  'rt',
  'ptm',
  'tmc',
  'sr',
  'mip',
  'twr',
  'grd',
  'bh',
  'mb',
  'gctpg',
  'rck79',
  'lpt8',
  'rck7d',
  'sol',
  'lpt11',
  'glt7m',
  'plp',
  'rck7r',
  'tyc88',
]);
